import script from "./PairPriceGraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./PairPriceGraph.vue?vue&type=script&setup=true&lang=ts"

import "./PairPriceGraph.vue?vue&type=style&index=0&id=2f91c88b&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f91c88b"]])

export default __exports__